import type { JSX } from 'preact';
import { Router } from './router';
import { routerConfig } from './routes';

export function App(): JSX.Element {
  return <Router config={routerConfig} />;
}
